import { UiStateType } from './ui.reducer';

export const isHeaderVisible = (state: UiStateType) => state.isHeaderVisible;
